<template>
    <div class="container">
        <consultar></consultar>
    </div>
</template>

<script>
import Consultar from './Consultar.vue';

export default {
    name : 'Terminar',
    components : {
        Consultar
    },
    data : () => ({

    }),
    computed:{
        labels(){
            if (this.$store.state._language == "es-ES") {
                return {
                    title : 'Terminar contrato',
                }
            }else{
                return {
                    title : 'Terminate contract',
                }
            }
        }
    }
}
</script>

<style>

</style>